(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/carousel/assets/javascripts/react/carousel-navigation.js') >= 0) return;  svs.modules.push('/components/tb-ui/carousel/assets/javascripts/react/carousel-navigation.js');

'use strict';

const _React = React,
  forwardRef = _React.forwardRef,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const _svs$ui = svs.ui,
  IconButton = _svs$ui.ReactIconButton,
  Icon = _svs$ui.ReactIcon;
const usePrevious = svs.components.tbUi.carousel.hooks.usePrevious;
const CarouselNavigation = forwardRef((_ref, ref) => {
  let numberOfPages = _ref.numberOfPages,
    onChange = _ref.onChange,
    selectedIndex = _ref.selectedIndex;
  const lastIndex = usePrevious(selectedIndex);
  const previousButtonRef = useRef(null);
  const nextButtonRef = useRef(null);
  const previous = () => {
    if (selectedIndex > 0) {
      onChange(selectedIndex - 1);
    }
  };
  const next = () => {
    if (selectedIndex + 1 < numberOfPages) {
      onChange(selectedIndex + 1);
    }
  };
  useEffect(() => {
    if (selectedIndex > lastIndex) {
      nextButtonRef === null || nextButtonRef === void 0 || nextButtonRef.current.focus();
    } else if (selectedIndex < lastIndex) {
      previousButtonRef === null || previousButtonRef === void 0 || previousButtonRef.current.focus();
    }
  }, [lastIndex, selectedIndex]);
  return React.createElement("div", {
    className: "ui-carousel-nav",
    "data-testid": "ui-carousel-navigation",
    ref: ref
  }, React.createElement("button", {
    "aria-disabled": selectedIndex === 0,
    "aria-label": "F\xF6reg\xE5ende sida",
    className: ['icon-button', 'ui-carousel-paging-btn', selectedIndex === 0 ? 'disabled' : ''].filter(Boolean).join(' '),
    "data-testid": "ui-carousel-navigation-previous",
    onClick: previous,
    ref: previousButtonRef,
    type: "button"
  }, React.createElement(Icon, {
    icon: "arrow-left",
    size: "200"
  })), React.createElement("div", {
    className: "ui-carousel-paging"
  }, React.createElement("span", null, selectedIndex + 1), React.createElement("span", null, "/"), React.createElement("span", null, numberOfPages)), React.createElement("button", {
    "aria-disabled": selectedIndex + 1 === numberOfPages,
    "aria-label": "N\xE4sta sida",
    className: ['icon-button', 'ui-carousel-paging-btn', selectedIndex + 1 === numberOfPages ? 'disabled' : ''].filter(Boolean).join(' '),
    "data-testid": "ui-carousel-navigation-next",
    onClick: next,
    ref: nextButtonRef,
    type: "button"
  }, React.createElement(Icon, {
    icon: "arrow-right",
    size: "200"
  })));
});
CarouselNavigation.defaultProps = {
  numberOfPages: 1,
  selectedIndex: 0
};
setGlobal('svs.components.tbUi.carousel.CarouselNavigation', CarouselNavigation);

 })(window);